import React, { memo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import ToggleSelector from 'Pods/ThreeDStudio/Shared/ToggleSelector/ToggleSelector'
import { setIsSmartLowPoly } from 'Pods/ThreeDStudio/Store/actions/modelSettings'

function SmartLowPolySelector() {
  const t = useTranslation()

  return (
    <ToggleSelector
      id="model-settings-smart-low-poly"
      keyName="isSmartLowPoly"
      label={t('leftSide.smartLowPoly.label')}
      setFunction={setIsSmartLowPoly}
      sliceName="modelSettings"
    />
  )
}

export default memo(SmartLowPolySelector)
